import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AuthPanel from '../components/Common/AuthPanel';
import { LoginBack, LoginHeader } from '../components/Common/Card';
import { AuthDesktopHeader } from '../components/Common/Dialog';

const MobileLoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const returnTo = params.get('von') || '/';
  const initialTab = params.get('tab') === 'registrieren' ? 'registrieren' : 'anmelden';

  // Bereits eingeloggt → zurück zur Ausgangsseite (z.B. direkter URL-Aufruf)
  useEffect(() => {
    if (isAuthenticated) {
      navigate(returnTo, { replace: true });
    }
  }, [isAuthenticated, navigate, returnTo]);

  const bgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/GrosselternMitKindern.png)`,
  };

  return (
    <div className="auth-fullpage" style={bgStyle}>
      <LoginBack returnTo={returnTo} />
      <LoginHeader
        title="Konto erstellen oder anmelden"
        subtitle="Melden Sie sich an, um Aktivitäten einzugeben und Ihre eingegebenen Aktivitäten anzuschauen"
      />
      <div className="auth-fullpage-panel">      
        <AuthDesktopHeader
          title="Konto erstellen oder anmelden"
          subtitle="Melden Sie sich an, um Aktivitäten einzugeben und Ihre eingegebenen Aktivitäten anzuschauen"
        />
        <AuthPanel
          returnTo={returnTo}
          initialTab={initialTab}
          hideHero
        />
      </div>
    </div>
  );
};

export default MobileLoginPage;
